// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"uD-z","smallCardRow":"vD-z","largeCardRow":"wD-z","productSearchRow":"xD-z","curatedRow":"yD-z"};